import wizardStyle from "@/src/components/Form/wizardStyle";

const feedbackFormStyle = {
  ...wizardStyle,
  button: {
    margin: "1rem 0",
  },
};
export default feedbackFormStyle;
